export default {
  "content": "<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#EBEBF0\"/><path d=\"M9.149 12.824h3.71V14H7.105v-.546l3.444-4.158c.574-.7.966-1.442.966-1.862 0-.924-.658-1.54-1.652-1.54-.994 0-1.68.56-1.75 1.386L7.02 7.042c.182-1.386 1.274-2.31 2.842-2.31 1.722 0 2.87 1.078 2.87 2.702 0 .714-.462 1.652-1.064 2.366l-2.52 3.024z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};